import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full flex items-center min-h-[420px] md:min-h-[500px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20minimal%20workspace%20with%20modern%20laptop%20and%20elegant%20accessories%20on%20cream%20marble%20desk%2C%20soft%20natural%20side%20lighting%2C%20aesthetic%20neutral%20beige%20and%20warm%20gray%20palette%2C%20clean%20editorial%20style%2C%20professional%20yet%20inviting%20atmosphere&width=1800&height=700&seq=cta-hipobuy-v2-bg&orientation=landscape"
        alt="Commencer avec Hipobuy Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/30"></div>

      <div className="relative z-10 w-full px-6 md:px-10 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
              Commencez maintenant avec le guide Hipobuy Spreadsheet
            </h2>
            <p className="text-base md:text-lg text-white/70 font-light leading-relaxed mb-10 max-w-lg">
              Accédez au guide complet, aux comparatifs et aux tutoriels avancés. Transformez votre façon de travailler avec les données.
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <Link
                to="/article/guide-complet-hipobuy-spreadsheet"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm whitespace-nowrap hover:bg-background-100 transition-all cursor-pointer"
              >
                Guide Complet
                <i className="ri-book-open-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/50 text-white font-semibold text-sm whitespace-nowrap hover:bg-white hover:text-foreground-900 transition-all cursor-pointer"
              >
                Hipobuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}